/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { PATH_PREFIX } from '../config/config';
import UnauthorizedError from '../errors/UnauthorizedError';

export default function redirectIfUnauthorized(error: Error, history: any): void {
  if (error instanceof UnauthorizedError) {
    window.sessionStorage.removeItem('token');
    window.sessionStorage.removeItem('isAdmin');
    history.push(`${PATH_PREFIX}/login`);
  }
}
